import { IDoctorRegisterStepRepository } from '../../interfaces/doctor-register-step-repository'
import { IApiRepository } from 'service/protocols/api/api-repository'
import { UpdateDoctorRegisterStep } from 'domain/usecases/doctor-register-step/update-doctor-register-step'
import { updateDoctorRegisterStepMutation } from 'repository/graphql/mutations'
import { makeGraphQLVariable } from '../../graphql/utils/make-variables'
import { ApiStatusCode } from 'service/protocols/api/api-client'
import handleGraphQLError from '../../graphql/utils/handle-error'
import { RepositoryErrors } from '../../errors/repository-errors'

export class DoctorRegisterStepRepository
  implements IDoctorRegisterStepRepository
{
  constructor(private readonly apiRepository: IApiRepository) {}

  async updateDoctorRegisterStep(
    params: UpdateDoctorRegisterStep.Params
  ): Promise<UpdateDoctorRegisterStep.Model> {
    const apiRepository = this
      .apiRepository as IApiRepository<UpdateDoctorRegisterStep.Model>

    const httpResponse = await apiRepository.post({
      url: '/graphql',
      body: {
        query: updateDoctorRegisterStepMutation.query,
        variables: makeGraphQLVariable(params)
      },
      query: updateDoctorRegisterStepMutation.name
    })

    if (
      httpResponse.statusCode &&
      httpResponse.statusCode !== ApiStatusCode.ok
    ) {
      throw handleGraphQLError(RepositoryErrors[httpResponse.error!])
    } else {
      return httpResponse.body as UpdateDoctorRegisterStep.Model
    }
  }
}
